export default "__VITE_ASSET__876362aa__"